import isFilledUp from './fields/isFilledUp'

import isDate from './fields/isDate'
import isGender from './fields/isGender'

// const validateDateOfBirth = (name, birthdate) => {
//   if (!isDate(birthdate) && isFilledUp(birthdate)) {
//     return { [name]: 'Invalid birthdate' }
//   }
//   return {}
// }

// const validateGender = (name, gender) => {
//   if (!isGender(gender) && isFilledUp(gender)) {
//     return { [name]: 'Invalid gender' }
//   }
//   return {}
// }

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { birthdate, gender } = values
  let validation = {}

  if (!isDate(birthdate) && isFilledUp(birthdate)) {
    validation = { birthdate: 'Invalid birthdate' }
  }

  if (!isGender(gender) && isFilledUp(gender)) {
    validation = { ...validation, gender: 'Invalid gender' }
  }

  if (!isFilledUp(birthdate) && !isFilledUp(gender)) {
    if (birthdate === undefined) validation = { status: 'Gender is required' }
    else if (gender === undefined)
      validation = { status: 'Birthdate is required' }
    else validation = { status: 'Gender or Birthdate  is required' }
  }

  return {
    ...validation,
    // ...validateDateOfBirth('birthdate', birthdate),
    // ...validateGender('gender', gender),
  }
}

export default validate
